import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { studentActions } from '../actions/student.actions';
import { statisticsActions } from '@app/store/statistics/actions/statistics.actions';

@Injectable()
export class AdminStudent_StatisticsEffects {
    private readonly actions = inject(Actions);

    reloadStatistics$ = createEffect(() => {
        return this.actions.pipe(
            ofType(studentActions.addStudentSuccess, studentActions.updateStudentSuccess, studentActions.deleteStudentSuccess),
            map(() => statisticsActions.getStatistics()),
        );
    });
}
